const localState = {
    list: [],
    problem: {
        name: '',
        service_id: null,
        id: null,
    },
    isShowModal: false,
    deleteId: '',
    deletion_tag: false,
}
const mutations = {
    setState: (state, {
        key,
        data,
    }) => {
        state[key] = data
    },
    setDeleteId: (state, v) => {
        state.deleteId = v
    },
    setDeletionStatus: (state, v) => {
        state.deletion_tag = v
    },
}

const actions = {
    async fetch({
        commit,
    }) {
        const response = await this.$api.problems.fetch()
        commit('setState', {
            key: 'list',
            data: response.data.data,
        })
    },
    async add(_, form) {
        const response = await this.$api.problems.add(form)
        return response.status === 201
    },
    async update(_, form) {
        const response = await this.$api.problems.update(form)
        return response.status === 200
    },
    async remove(_, id) {
        await this.$api.problems.remove(id)
    },
}

const getters = {
    list: (state) => state.list,
    problem: (state) => state.problem,
    isShowModal: (state) => state.isShowModal,
    deletionStatus: (state) => state.deletion_tag,
}

export default {
    namespaced: true,
    state: localState,
    mutations,
    actions,
    getters,
}
